






























import { Component, mixins } from '@niknevis/vue-modules'
import { FilterComponentsMixin } from '@/modules/common/filter/mixins/filterComponentsMixin'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'

@Component({
  components: { BaseSelect }
})
export default class Select extends mixins(FilterComponentsMixin) {
  protected default = []

  get label() {
    return this.filter.title
  }

  get holder() {
    return this.filter.holder
  }

  get typeMode() {
    return this.filter.typeMode
  }
}
